var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip.top.center",
          value: { content: _vm.description },
          expression: "{ content: description }",
          modifiers: { top: true, center: true }
        }
      ],
      staticClass: "btn btn-link",
      attrs: { href: _vm.link, target: "_blank", rel: "noopener noreferrer" }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.title) + "\n  "),
      _c("span", { staticClass: "sr-only" }, [
        _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
      ]),
      _vm._v(" "),
      _vm.title == _vm.$t("Btn_AidInstructions")
        ? _c("i", { staticClass: "fas fa-file-pdf" })
        : _c("i", { staticClass: "fas fa-external-link-alt" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }